export { default as bleMiddleware } from './BLEMiddleware';
